document.addEventListener('DOMContentLoaded', function () {
    const footer = document.querySelector('.home-hero__footer');
    const footerItems = document.querySelectorAll('.home-hero__footer-item-mobile img');
    const fadeDuration = window.homeHeroSettings.animationSpeed; // milliseconds for fade in/out
    const displayDuration = window.homeHeroSettings.animationDuration; // time the item stays fully visible

    const collectionHero = document.querySelector('.home-hero');
    const scrollThreshold = 100; // Scroll position in pixels
    const scaleValue = 0.977777777777778; // Value to scale the image
    const scaleValueMobile = 0.946808510638298; // Value to scale the image

    // Variables to track animation state and cleanup
    let currentAnimation = null;
    let resizeTimeout = null;

    function clearCurrentAnimation() {
        if (currentAnimation) {
            clearTimeout(currentAnimation.displayTimeout);
            clearTimeout(currentAnimation.fadeTimeout);
            currentAnimation = null;
        }
    }

    function applyFooterStyles() {
        // Clear any existing animation before starting a new one
        clearCurrentAnimation();

        if (window.innerWidth < 600) {
            const footer = document.querySelector('.home-hero__footer');
            const footerItems = document.querySelectorAll('.home-hero__footer-item-mobile img');

            // Center the footer container
            footer.style.display = 'flex';
            footer.style.justifyContent = 'center';
            footer.style.alignItems = 'center';
            footer.style.position = 'relative';

            // Set initial styles for each footer item
            footerItems.forEach((item) => {
                item.style.opacity = '0';
                item.style.position = 'absolute';
                item.style.transition = `opacity ${window.homeHeroSettings.animationSpeed}ms ease-in-out`;
            });

            // Start with the second item (index 1)
            let currentIndex = 1;
            footerItems[currentIndex].style.opacity = '1';

            function animateItem(index) {
                // Ensure the current item is visible
                footerItems[index].style.opacity = '1';

                // After displayDuration, fade it out
                const displayTimeout = setTimeout(() => {
                    footerItems[index].style.opacity = '0';
                    const fadeTimeout = setTimeout(() => {
                        // Only continue if this animation hasn't been cleared
                        if (currentAnimation && currentAnimation.displayTimeout === displayTimeout) {
                            // Animate the next item in sequence
                            animateItem((index + 1) % footerItems.length);
                        }
                    }, fadeDuration);

                    // Update current animation reference
                    if (currentAnimation && currentAnimation.displayTimeout === displayTimeout) {
                        currentAnimation.fadeTimeout = fadeTimeout;
                    }
                }, displayDuration);

                // Store timeout references for cleanup
                currentAnimation = {
                    displayTimeout: displayTimeout,
                    fadeTimeout: null,
                };
            }

            // Start the animation immediately so the second item is visible only for displayDuration
            animateItem(currentIndex);
        } else {
            const footer = document.querySelector('.home-hero__footer');
            const footerItems = document.querySelectorAll('.home-hero__footer-item-desktop img');

            footerItems.forEach((item) => {
                item.style.opacity = '0';
                item.style.position = 'absolute';
                item.style.transition = `opacity ${window.homeHeroSettings.animationSpeed}ms ease-in-out`;
            });

            // Start with the second item (index 1)
            let currentIndex = 0;
            footerItems[0].style.opacity = '1';

            function animateItem(index) {
                // Ensure the current item is visible
                footerItems[index].style.opacity = '1';

                // After displayDuration, fade it out
                const displayTimeout = setTimeout(() => {
                    footerItems[index].style.opacity = '0';
                    const fadeTimeout = setTimeout(() => {
                        // Only continue if this animation hasn't been cleared
                        if (currentAnimation && currentAnimation.displayTimeout === displayTimeout) {
                            // Animate the next item in sequence
                            animateItem((index + 1) % footerItems.length);
                        }
                    }, fadeDuration);

                    // Update current animation reference
                    if (currentAnimation && currentAnimation.displayTimeout === displayTimeout) {
                        currentAnimation.fadeTimeout = fadeTimeout;
                    }
                }, displayDuration);

                // Store timeout references for cleanup
                currentAnimation = {
                    displayTimeout: displayTimeout,
                    fadeTimeout: null,
                };
            }

            animateItem(currentIndex);
        }
    }

    // Debounced resize handler to prevent excessive calls
    function handleResize() {
        // Clear existing timeout
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        // Set new timeout
        resizeTimeout = setTimeout(() => {
            applyFooterStyles();
        }, 150); // 150ms debounce delay
    }

    // Function to handle scroll event
    function handleScroll() {
        const scrollPosition = window.scrollY;

        if (scrollPosition >= scrollThreshold) {
            if (window.innerWidth < 600) {
                collectionHero.style.transform = `scale(${scaleValueMobile})`;
            } else {
                collectionHero.style.transform = `scale(${scaleValue})`;
            }
            collectionHero.style.transition = 'transform 0.3s ease'; // Smooth transition
        } else {
            collectionHero.style.transform = 'scale(1)';
            collectionHero.style.transition = 'transform 0.3s ease'; // Smooth transition
        }
    }

    applyFooterStyles();

    // Listen to the scroll event
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    const reviewElement = document.querySelector('.home-hero__main-review');

    if (reviewElement) {
        // Create an Intersection Observer
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // If the element is in view, set opacity to 1 after 1 second
                        setTimeout(function () {
                            reviewElement.style.opacity = '1';
                            reviewElement.style.transition = 'opacity 0.5s ease-in-out';
                        }, 1000);

                        // Unobserve the element once animation is triggered
                        observer.unobserve(reviewElement);
                    }
                });
            },
            {
                threshold: 0.1, // Trigger when at least 10% of the element is visible
            },
        );

        // Start observing the element
        observer.observe(reviewElement);
    }
});
